import type { ReactNode } from 'react';

/**
 * Encabezado de sección del panel de la campanita.
 *
 * Estaba escrito cinco veces con las mismas doce clases: cuatro inline en
 * `NotificationBell.tsx` y una en `NotificationsSection.tsx`. Cualquier cambio
 * de estilo había que acordarse de hacerlo cinco veces, y en la práctica ya
 * habían divergido (una usaba 9.5px y otra 10px).
 *
 * `aside` es el contador de la derecha: la cantidad, la acción de marcar leído,
 * o nada.
 */
export function PanelSectionHeader({
  title,
  aside,
}: {
  title: ReactNode;
  aside?: ReactNode;
}) {
  return (
    <div className="border-border-dim text-fg-muted flex items-center justify-between border-b px-3.5 py-1.5 text-micro font-medium">
      <span>{title}</span>
      {aside}
    </div>
  );
}
